var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 1.33325C8.36827 1.33325 8.66675 1.63173 8.66675 1.99992V8.39042L10.862 6.19514C11.1224 5.93479 11.5445 5.93479 11.8048 6.19514C12.0652 6.45549 12.0652 6.8776 11.8048 7.13795L8.47466 10.4681C8.46199 10.481 8.44879 10.4933 8.43511 10.5051C8.39035 10.5437 8.34168 10.5754 8.29049 10.6002C8.20271 10.6427 8.10418 10.6666 8.00008 10.6666C7.88585 10.6666 7.77832 10.6379 7.68434 10.5872C7.65529 10.5716 7.62715 10.5536 7.6002 10.5334C7.57285 10.5129 7.54714 10.4903 7.52328 10.4659L4.19536 7.13795C3.93501 6.8776 3.93501 6.45549 4.19536 6.19514C4.45571 5.93479 4.87782 5.93479 5.13817 6.19514L7.33341 8.39038V1.99992C7.33341 1.63173 7.63189 1.33325 8.00008 1.33325ZM2.66671 10C2.66671 9.63184 2.36823 9.33336 2.00004 9.33336C1.63185 9.33336 1.33337 9.63184 1.33337 10V12.6667C1.33337 13.1971 1.54409 13.7058 1.91916 14.0809C2.29423 14.456 2.80294 14.6667 3.33337 14.6667H12.6667C13.1971 14.6667 13.7058 14.456 14.0809 14.0809C14.456 13.7058 14.6667 13.1971 14.6667 12.6667V10C14.6667 9.63184 14.3682 9.33336 14 9.33336C13.6319 9.33336 13.3334 9.63184 13.3334 10V12.6667C13.3334 12.8435 13.2631 13.0131 13.1381 13.1381C13.0131 13.2631 12.8435 13.3334 12.6667 13.3334H3.33337C3.15656 13.3334 2.98699 13.2631 2.86197 13.1381C2.73695 13.0131 2.66671 12.8435 2.66671 12.6667V10Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/download.03a56351a2a08fea7a748028e7f7ef6b.svg";